import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CopyOutlined, DeleteOutlined, ScanOutlined } from "@ant-design/icons";
import { Layout } from "antd";
import { observer } from "mobx-react";
import { AnalyseResult } from "./analyseResult.js";
import { __ } from "../utils/i18n.js";
const { Footer } = Layout;
const AnalyseFooter = observer(()=>{
    return /*#__PURE__*/ _jsx(Footer, {
        style: {
            textAlign: "center"
        },
        children: /*#__PURE__*/ _jsxs(AnalyseResult, {
            style: {
                display: "inline-block",
                margin: 0,
                fontSize: "12px"
            },
            legend: "Legend",
            children: [
                /*#__PURE__*/ _jsxs("li", {
                    children: [
                        /*#__PURE__*/ _jsx(CopyOutlined, {}),
                        " ",
                        __("Generated thumbnail files")
                    ]
                }),
                /*#__PURE__*/ _jsxs("li", {
                    children: [
                        /*#__PURE__*/ _jsx(ScanOutlined, {}),
                        " ",
                        __("Needs to be generated")
                    ]
                }),
                /*#__PURE__*/ _jsxs("li", {
                    children: [
                        /*#__PURE__*/ _jsx(DeleteOutlined, {}),
                        " ",
                        __("Unused thumbnail files")
                    ]
                })
            ]
        })
    });
});
export { AnalyseFooter };
